import { randomNumber } from "../../../../helpers/randomNumber";
import {
  setErrorMsg,
  setSuccessMsg,
  uiCloseModalAdd,
  uiCloseModalDelete,
  uiCloseModalEdit,
  uiOpenErrorAlert,
  uiOpenSuccessAlert,
} from "../../../../redux/actions/uiActions";
import { IParamProcedure, Types } from "../../../../redux/types/types";
import { getCorrespondenceByParamProcedure } from "../../../../services/firebase/correspondence";
import {
  addOrUpdateProcedure,
  deleteProcedureFirebase,
  loadProcedureById,
  loadProcedureByName,
  loadProcedures,
} from "../../firebase/formalitiesService";
import { IValidateFormalities } from "../../form/IValidateFormalities";

// Agregar o actualizar trámite
export const startNewProcedure = (procedure: IParamProcedure) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { activeParamProcedure } = getState().correspondence;
    procedure.procedureName = procedure.procedureName.trim();
    if (!!activeParamProcedure) {
      const result = await validateProcedureCorrespondence(
        procedure.id,
        idEntity,
        "ProcedureLabel.AlertUpdateProcedure"
      )(dispatch);

      if (result) {
        dispatch(uiCloseModalEdit());
        return;
      }

      // Editar trámite
      const { ok } = await addOrUpdateProcedure(idEntity, procedure);

      if (ok) {
        dispatch(updateProcedure(procedure));
        dispatch(setSuccessMsg("ProcedureLabel.ProcedureUpdated"));
        dispatch(uiCloseModalEdit());
        dispatch(setActiveProcedure(null));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("ProcedureLabel.ErrorProcedureUpdate"));
        dispatch(uiOpenErrorAlert());
      }
    } else {
      // Crear nuevo trámite
      const random = randomNumber(1, 1000000);
      procedure.id = `${random}_${Date.now()}`;

      // Construcción de valores iniciales
      const validationParams: IValidateFormalities = {
        idParamProcedure: "0",
        idEntity: idEntity,
        nameParamProcedure: procedure.procedureName,
      };

      // Obtener procedimiento por ID
      const procedureData = await loadProcedureByName(validationParams);

      if (procedureData != null) {
        dispatch(setErrorMsg("ProcedureLabel.AlertCreateProcedure"));
        dispatch(uiCloseModalAdd());
        dispatch(uiOpenErrorAlert());
        return;
      }

      const { ok } = await addOrUpdateProcedure(idEntity, procedure);

      if (ok) {
        dispatch(addProcedure(procedure));
        dispatch(setSuccessMsg("ProcedureLabel.ProcedureCreated"));
        dispatch(uiCloseModalAdd());
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("ProcedureLabel.ErrorProcedureCreate"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};
const addProcedure = (procedure: IParamProcedure) => ({
  type: Types.addProcedure,
  payload: procedure,
});

const updateProcedure = (procedure: IParamProcedure) => ({
  type: Types.updateProcedure,
  payload: procedure,
});

// Activar trámite
export const setActiveProcedure = (procedure: IParamProcedure | null) => ({
  type: Types.setActiveProcedure,
  payload: procedure,
});

// Eliminar trámite
export const startDeleteProcedure = (idProcedure: string) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;

    const result = await validateProcedureCorrespondence(
      idProcedure,
      idEntity,
      "ProcedureLabel.AlertDeletedProcedure"
    )(dispatch);

    if (result) {
      dispatch(uiCloseModalDelete());
      return;
    }

    const { ok } = await deleteProcedureFirebase(idEntity, idProcedure);

    if (ok) {
      dispatch(deleteProcedure(idProcedure));
      dispatch(setSuccessMsg("ProcedureLabel.ProcedureDeleted"));
      dispatch(uiOpenSuccessAlert());
    } else {
      dispatch(setErrorMsg("ProcedureLabel.ProcedureDeletedError"));
      dispatch(uiOpenErrorAlert());
    }

    dispatch(uiCloseModalDelete());
  };
};

const deleteProcedure = (idProcedure: string) => ({
  type: Types.deleteProcedure,
  payload: idProcedure,
});

// Cargar trámites
export const startLoadingProcedures = (idEntity: string) => {
  return async (dispatch: Function) => {
    const procedures = await loadProcedures(idEntity);
    dispatch(setProcedures(procedures));
  };
};

// Setear trámites
export const setProcedures = (procedures: IParamProcedure) => ({
  type: Types.loadParamsProcedure,
  payload: procedures,
});

export const validateProcedureCorrespondence = (
  procedureId: string,
  entityId: string,
  errorMessage: string
) => {
  return async (dispatch: Function) => {
    // Construcción de valores iniciales
    const validationParams: IValidateFormalities = {
      idParamProcedure: procedureId,
      idEntity: entityId,
      nameParamProcedure: "",
    };

    // Obtener procedimiento por ID
    const procedureData = await loadProcedureById(validationParams);
    validationParams.nameParamProcedure = procedureData.procedureName;

    // Validar correspondencias
    const correspondenceData = await getCorrespondenceByParamProcedure(
      validationParams
    );

    if (correspondenceData.length > 0) {
      dispatch(setErrorMsg(errorMessage));
      dispatch(uiOpenErrorAlert());

      return true;
    }

    return false;
  };
};
